import styles from "./index.module.scss";

type InputProps = {
    value: string;
    onChange: (content: string) => void;

    placeholder: string;

    length: "short" | "long";
    type: "text" | "email" | "tel";
};

export const Input = (props: InputProps) => {

    if(props.length === "short") {
        return (
            <input
                type={props.type}
                placeholder={props.placeholder}
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                required
                pattern={props.type === "tel" ? "[0-9]{10}" : undefined}
                className={styles.input}
            />
        );
    } else {
        return (
            <textarea
                placeholder={props.placeholder}
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                rows={5}
                required
                className={styles.input}
            />
        );
    }
}